import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { clearLocalStorage, clearSessionStorage, setLocalStorage } from './local-storage.actions';
import { StorageService } from 'src/app/shared/services/global/storage.service';

@Injectable()
export class LocalStorageEffects {
    constructor(private actions$: Actions,
        private storageService: StorageService
    ) { }

    setLocalStorage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(setLocalStorage),
            tap(action => {
                this.storageService.setLocalStorage(action.key, action.data);
            })
        ), { dispatch: false }
    );

    setSessionStorage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(setLocalStorage),
            tap(action => {
                this.storageService.setLocalStorage(action.key, action.data);
            })
        ), { dispatch: false }
    );

    clearLocalStorage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(clearLocalStorage),
            tap(action => {
                if (action.keys.length > 0) {
                    action.keys.forEach(key => {
                        this.storageService.removeLocalStorage(key);
                    });
                }
            })
        ), { dispatch: false }
    );

    clearSessionStorage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(clearSessionStorage),
            tap(action => {
                if (action.keys.length > 0) {
                    action.keys.forEach(key => {
                        this.storageService.removeSessionStorage(key);
                    });
                }
            })
        ), { dispatch: false }
    );
}
